
import { X, CheckSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

import type { BulkAction } from '@/shared/schemas';
export type { BulkAction };

interface BulkActionBarProps {
    selectedCount: number;
    totalCount?: number; // Optional, to show "Select all X items" logic if needed
    onClearSelection: () => void;
    actions: BulkAction[];
    className?: string;
}

export function BulkActionBar({
    selectedCount,
    onClearSelection,
    actions,
    className
}: BulkActionBarProps) {
    if (selectedCount === 0) return null;

    return (
        <div className={cn(
            "fixed bottom-6 left-1/2 -translate-x-1/2 z-50 flex items-center gap-4 bg-slate-900/90 text-white px-4 py-3 rounded-full shadow-2xl backdrop-blur-sm animate-in slide-in-from-bottom-5 fade-in duration-300 border border-slate-700/50 min-w-[300px] max-w-[90vw]",
            className
        )}>
            <div className="flex items-center gap-3 pr-4 border-r border-slate-700/50">
                <div className="bg-indigo-500 text-white text-xs font-bold px-2 py-0.5 rounded flex items-center gap-1">
                    <CheckSquare className="w-3 h-3" />
                    {selectedCount}
                </div>
                <span className="text-sm font-medium whitespace-nowrap">Đã chọn</span>
            </div>

            <div className="flex items-center gap-2 flex-nowrap overflow-x-auto no-scrollbar scroll-smooth">
                {actions.map((action, index) => (
                    <Button
                        key={index}
                        variant={action.variant || "secondary"}
                        size="sm"
                        onClick={action.onClick}
                        disabled={action.disabled}
                        className={cn("h-8 text-xs font-medium gap-1.5 whitespace-nowrap", action.className)}
                    >
                        {action.icon}
                        {action.label}
                    </Button>
                ))}
            </div>

            <div className="pl-2 border-l border-slate-700/50 ml-auto">
                <Button
                    variant="ghost"
                    size="icon"
                    onClick={onClearSelection}
                    className="h-7 w-7 rounded-full text-slate-400 hover:text-white hover:bg-slate-800"
                >
                    <X className="w-4 h-4" />
                </Button>
            </div>
        </div>
    );
}
